export const DEFAULT_LOGIN_BACKGROUND_IMAGE =
  'https://evisit.s3.amazonaws.com/backgrounds/medical/AdobeStock_94813212_blurred.jpg';

export const AUTH_PARAMS_STORAGE_KEY = '_eVisitRememberAccount';
